import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { LoginUserJoinForm } from './LoginUserJoinForm';
import { LoginUserJoinInfo } from './LoginUserJoinInfo';

export const LoginUserJoinMain = (oProps: any) => {
  const navigate = useNavigate();
  const [userJoinSuccess, setUserJoinSuccess] = React.useState<boolean>(false);
  const [userId, setUserId] = React.useState<string>('');
  const [userPw, setUserPw] = React.useState<string>('');
  const [userPwCheck, setUserPwCheck] = React.useState<string>('');
  const [ceoName, setCeoName] = React.useState<string>('');
  const [storeName, setStoreName] = React.useState<string>('');
  const [businessNumber, setBusinessNumber] = React.useState<string>('');
  const [userEmailFront, setUserEmailFront] = React.useState<string>('');
  const [userEmailBack, setUserEmailBack] = React.useState<string>('');
  const [userPhoneNumber, setUserPhoneNumber] = React.useState<string>('');
  const [partnersId, setPartnersId] = React.useState<string>('');
  const email = `${userEmailFront}@${userEmailBack}`;

  const moveLoginPage = () => {
    navigate('/');
  };
  return (
    <Style>
      <div className="wrap">
        <div className="container">
          <div className="content">
            <button onClick={moveLoginPage} className="behindLogo">
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_logo_black.svg`}
                alt="logo"
                width="100%"
                style={{
                  maxWidth: '80px',
                }}
              />
            </button>
            <h1 className="title">회원가입</h1>
            {/* 회원가입 전 */}
            {!userJoinSuccess && (
              <LoginUserJoinForm
                setUserJoinSuccess={setUserJoinSuccess}
                userId={userId}
                userPw={userPw}
                userPwCheck={userPwCheck}
                ceoName={ceoName}
                storeName={storeName}
                businessNumber={businessNumber}
                userEmailFront={userEmailFront}
                userEmailBack={userEmailBack}
                userPhoneNumber={userPhoneNumber}
                email={email}
                partnersId={partnersId}
                setUserId={setUserId}
                setUserPw={setUserPw}
                setUserPwCheck={setUserPwCheck}
                setCeoName={setCeoName}
                setStoreName={setStoreName}
                setBusinessNumber={setBusinessNumber}
                setUserEmailFront={setUserEmailFront}
                setUserEmailBack={setUserEmailBack}
                setUserPhoneNumber={setUserPhoneNumber}
                setPartnersId={setPartnersId}
              />
            )}
            {/* 회원가입 후 */}
            {userJoinSuccess && (
              <LoginUserJoinInfo
                userId={userId}
                ceoName={ceoName}
                storeName={storeName}
                email={email}
                userPhoneNumber={userPhoneNumber}
                moveLoginPage={moveLoginPage}
                partnersId={partnersId}
              />
            )}
          </div>
          <div className="footer">
            <p>Copyright 2023. Invisible Ideas. All rights reserved</p>
          </div>
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  ul,
  li {
    list-style: none;
  }
  .wrap {
    width: 100%;
    min-height: 100vh;
    background: #f8fafc;
  }
  .container {
    width: 100%;
    max-width: 30rem;
    margin: 0 auto;
    min-height: 100vh;
    padding: 3rem !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.5rem;
  }
  .content {
    width: 100%;

    .behindLogo {
      border: none;
      outline: none;
      background: none;
    }
  }
  h1 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #4f5459;
  }
  button,
  label,
  label > input {
    cursor: pointer;
  }

  .title {
    margin-top: 3.5rem;
    margin-bottom: 2rem;
  }

  /* loginForm */
  .loginForm {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;

    label {
      margin-top: 12px;
      margin-bottom: 6px;
      font-size: 14px;
      font-weight: 500;
      color: #4f5459;
    }
    input {
      padding: 10px 14px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      outline: none;
    }
  }

  /* errorMessage */
  .errorMessage {
    width: 100%;
    margin: 4px 0;
    color: #f04438;
    font-size: 14px;
    font-weight: 500;
  }

  /* footer */
  .footer {
    p {
      margin: 0.25rem 0 0 0;
      font-size: 1rem;
      font-weight: 400;
      color: #72727e;
    }
  }

  @media (max-width: 800px) {
    .wrap {
      max-height: calc(var(--vh, 1vh) * 100);
      background: #fff;
    }
    .container {
      width: 100%;
      max-width: 100%;
      padding: 20px !important;
    }
    .title {
      margin-top: 32px;
      margin-bottom: 20px;
    }
    .loginFind {
      button {
        margin-left: 8px;

        p {
          font-size: 12px;
        }
      }
    }
    .footer {
      p {
        font-size: 12px;
      }
    }
  }
`;
